import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=3035fc17&scoped=true&"
import script from "./Callback.vue?vue&type=script&lang=js&"
export * from "./Callback.vue?vue&type=script&lang=js&"
import style0 from "./Callback.vue?vue&type=style&index=0&id=3035fc17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035fc17",
  null
  
)

export default component.exports